import { useEffect, useState } from "react"
import { url } from "../../weburl"
import DogCardList from "../../home/dog-card-list"
import axios from "axios"
import Navbar from "../../home/navbar"
import { AdminNav } from "../mini-components/admin_nav"
import { AdminSidePane } from "../mini-components/admin-side-pane"
import { Link } from "react-router-dom"
import { AdminMainWrapper } from "../mini-components/admin-main-wrapper"
import { AdminDogsDetailSearch } from "./adminDogDetailsSearch"

export const AdminAllDogs = () => {
    const [dogs, setDogs] = useState([])

    useEffect(() => {
        getAllDogs()
    }, [])
    const getAllDogs = () => {
        axios.get(`${url}api/dogs`)
            .then((res) => setDogs(res.data))
            .catch((err) => console.log(err))
    }

    const displayDogs = () => {
        if (dogs) {
            return dogs.map((item) => {
                if (item['id'] != 404) {
                    return <div className="col-sm-4">
                        <Link to={`/admin/dogs-detail/${item['id']}`}>
                            <DogCardList dogname={item['name']}
                                breed={item['breed']}
                                data_registered={item['date_registered']} />
                        </Link>
                    </div>
                }

            })
        }

    }
    return (
        <AdminMainWrapper>

            <div className="row align-items-center justify-content-center pt-4">
                <div className="col-sm-10">
                    <AdminDogsDetailSearch
                        customDogsArray={true}
                        setSearchDogs={setDogs} />
                </div>
            </div>
            <div className="row align-items-center justify-content-center bg-white">

                {displayDogs()}

            </div>

        </AdminMainWrapper>
    )
}